
//to make it globally accessible
window.freeItemSnippet = (hasFreeFurnitureCover = false, hasFreeGift = false, inventoryAvailable, html) => {
  let label = '';

  if (inventoryAvailable) {
      if (hasFreeFurnitureCover && hasFreeGift) {
          label = 'Free Gift';
      } else if (hasFreeFurnitureCover && !hasFreeGift) {
          label = 'Free Furniture Cover';
      } else if (!hasFreeFurnitureCover && hasFreeGift) {
          label = 'Free Gift';
      } else {
          // Neither free furniture cover nor free gift available
          label = '';
      }
  }

  if(label) {
      return html`      
      <div class="free-item-badge badge--free">
          <div class="free-item-badge__icon-container">
            <svg width="10" height="10" viewBox="0 0 7 5" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.18513 1.12744L6.18651 1.12562C6.30542 0.988499 6.36447 0.810207 6.35065 0.629967C6.33684 0.449727 6.2513 0.282303 6.11286 0.164528C6.04431 0.106212 5.96483 0.0618401 5.87897 0.0339457C5.7931 0.00605126 5.70253 -0.00481918 5.61242 0.00195498C5.43045 0.015636 5.26141 0.100357 5.1425 0.23748L2.4143 3.3178L1.56165 2.47284C1.49774 2.40954 1.42186 2.35932 1.33836 2.32507C1.25486 2.29081 1.16536 2.27318 1.07498 2.27318C0.984592 2.27318 0.895094 2.29081 0.811591 2.32507C0.728088 2.35932 0.652215 2.40954 0.588305 2.47284C0.524394 2.53614 0.473697 2.61128 0.439109 2.69399C0.404521 2.7767 0.386719 2.86534 0.386719 2.95486C0.386719 3.04438 0.404521 3.13302 0.439109 3.21573C0.473697 3.29844 0.524394 3.37358 0.588305 3.43688L1.96457 4.80046C2.09719 4.93227 2.27433 5.00045 2.46936 5H2.47808C2.57273 4.99635 2.6656 4.9734 2.75088 4.93257C2.83616 4.89175 2.91202 4.83393 2.9737 4.76274L6.18513 1.12744Z" fill="#D9D9D9"/>
          </svg>
          </div>
          <span>
            ${label}
          </span>
      </div>`;
  } else{
      return '';
  }
}

const loadSavingRecentSearches = () => {
  document.querySelector('.aa-Form')?.addEventListener('submit', function() {
    // Get search query from either input or detached button query
    const inputElement = document.querySelector('.aa-Input');
    const detachedQueryElement = document.querySelector('.aa-DetachedSearchButtonQuery');
    
    const searchQuery = (inputElement?.value || detachedQueryElement?.textContent || '').trim();
    
    if (searchQuery) {
      let recentSearches = JSON.parse(localStorage.getItem('recent_searches') || '[]');
      
      // Remove duplicate if exists and add to beginning
      recentSearches = [
        searchQuery,
        ...recentSearches.filter(query => query !== searchQuery)
      ].slice(0, 5); // Limit to 5 items
      
      localStorage.setItem('recent_searches', JSON.stringify(recentSearches));
    }
  });
}

document.addEventListener('algolia.hooks.initialize', function() {
  const generateStarRating = (item, html, minReviewThreshold = 5) => {
    // Extract rating and count with fallback defaults
    const reviewsData = item?.meta?.reviews || {};
    const rawRating = reviewsData.rating || 0;
    const ratingCount = reviewsData.rating_count || 0;
    let rating = 0;
    
    try {
      rating = typeof rawRating === 'string' ? JSON.parse(rawRating).value : rawRating;
    } catch (error) {
      console.error('Error parsing rating:', error);
    }

    const totalRatingPercentage = Math.min(Math.max((rating / 5) * 100, 0), 100);
    const showRating = ratingCount >= minReviewThreshold;
    const ratingCountText = showRating ? `(${ratingCount})` : '';

    // Generate HTML only if we should show the rating
    return showRating 
      ? html`
          <div class="stars-container">
            <div class="stars-content">
              <p class="star-ratings">
                <span class="fill-ratings" style="width: ${totalRatingPercentage}%;">
                  <span>★★★★★</span>
                </span>
                <span class="empty-ratings">
                  <span>★★★★★</span>
                </span>
              </p>
              <p class="rating-count-text">${ratingCountText}</p>
            </div>
          </div>`
      : '';
  }

  const renderRecentSearches = (html) => {
    const recentSearches = JSON.parse(localStorage.getItem('recent_searches') || '[]');

    if (!recentSearches || !recentSearches.length) {
      return '';
    }
    
    const clockSvg = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="recent-search-icon">
      <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
    </svg>`;
    
    return html`
      <ul class="recent-searches-list">
        ${recentSearches.map(search => html`
          <li class="recent-searches-list__item">
            <a href="/search?q=${search}" class="recent-searches-list__link">
              ${html([clockSvg])}
            <span>${search}</span>
            </a>
          </li>
        `)}
      </ul>
    `;
  }

  algoliaShopify.hooks.registerHook('beforeAutocompleteMainTemplate', function(_defaultTemplate, templateOptions, elements, displaySuggestions) {
    const { html, state } = templateOptions;
    const recentSearches = renderRecentSearches(html)

    // Create a function that returns HTM template literal for recently viewed items
    const getRecentViewTemplate = (item) => {

      const hasFreeGift = item.hasFreeGift || '';
      const hasFreeFurnitureCover = item.hasFreeFurnitureCover || '';
      const algoliaQueryId = item.queryId || '';
      const algoliaPosition = item.position || '';
      const validQueryId = algoliaQueryId && algoliaQueryId !== 'undefined' && algoliaQueryId !== '' ? algoliaQueryId : null; 
      
      return html`
        <div class="header__recently-viewed__product gtm-click-event" id="product-${item.productID}" 
          data-item_id="${item.productID}"
          data-item_name="${item.productTitle}"
          data-price="${item.productPrice}"
          data-compare_at_price="${item.productCompareAtPrice}"
          data-algolia-objectid="${item.objectID}"
          data-algolia_queryid="${item.queryId ? item.queryId : ''}"
          data-algolia_position="${item.position ? item.position : ''}"
          data-handle="${item.productUrl}"
          data-variant-id="${item.objectID}"
          data-image="${item.productImg}"
          data-tags="${item.productTags}"
          data-available="${item.productAvailability}"
          data-object-id="${item.objectID}" 
          data-has_freegift="${hasFreeGift}"
          data-has_freefurniturecover="${hasFreeFurnitureCover}"
          onClick="${() => (item.objectID && item.objectID !== '') ? algoliaClickedEvent('Recently Viewed Product Clicked', [item.objectID], validQueryId, algoliaPosition) : null}"
        >
          <a class="header__recently-viewed__product-link" 
            data-id="${item.productID}" 
            data-object-id="${item.objectID}" 
            style="all:unset;" 
            href="/products/${item.productUrl}"
          > 
            <div class="header__recently-viewed__product-image">
              <img src="${item.productImg}" />
              ${ freeItemSnippet(hasFreeFurnitureCover, hasFreeGift, item.productAvailability, html)}
            </div>
            <div class="header__recently-viewed__product-details">
              <h4 class="header__recently-viewed__product-title">
                ${item.productTitle}
              </h4>
              <div class="header__recently-viewed__product-price">
                ${item.productCompareAtPrice && item.productCompareAtPrice > 0 
                  ? html`<p class="remove-spacing compare-at-price-recent">
                      <span class="compare-at-price">${formatMoney(item.productCompareAtPrice)}</span>
                    </p>` 
                  : ''}
                <p class="remove-spacing price-recently">${formatMoney(item.productPrice)}</p>
              </div>
            </div>
          </a>
        </div>
      `;
    };

    // Get recently viewed products and filter out ads
    const recentProducts = (JSON.parse(localStorage.getItem('recently_viewed_items')) || [])
      .filter(item => !item.productTags.includes('is_advert'));

    // Return the template with proper HTM rendering
    return html`
      <div class="aa-PanelLayout aa-Panel--scrollable">
        <div class="aa-PanelSections">
          <div class="aa-PanelSection--left">
            ${displaySuggestions &&
              html`
                <div class="aa-SourceHeader">
                  <span class="aa-SourceHeaderTitle">
                    ${trendingSearchesHeading}
                  </span>
                </div>
                ${elements.querySuggestionsPlugin}
              `}
            
              ${recentSearches !== ''  
                ? html`<div class="aa-SourceHeader">
                      <span class="aa-SourceHeaderTitle">
                        ${recentSearchHeading}
                      </span>
                    </div>
                    <div id="recent-searches">
                      ${recentSearches}
                    </div>`
                : html`<div id="autocomplete-popular-collection">
                      ${elements.collections}
                    </div>`
              }
          </div>
          ${state.query.trim() == '' && recentProducts.length > 0 
            ? html`
              <div class="aa-PanelSection--right">
                <div id="autocomplete-popular-colltion-recent">
                  <div class="aa-SourceHeader">
                    <span class="aa-SourceHeaderTitle aa-heading">Recently Viewed</span>
                  </div>
                  <div id="recently-search-algolia" class="header__recently-viewed">
                    ${recentProducts.slice(0, 4).map(item => getRecentViewTemplate(item))}
                  </div>
                </>
              </div>`
            : html`
              <div class="aa-PanelSection--right">
                ${elements.products}
              </div>`
          }
        </div>
      </div>
    `;
  });

  algoliaShopify.hooks.registerHook('beforeAutocompleteOptions', function(options) {
    options.openOnFocus = true;
    options.autoFocus = true;
    options.panelContainer = '.header-panel-container'
    options.detachedMediaQuery = '(max-width: 989px)'

    return options;
  });

  algoliaShopify.hooks.registerHook("beforeAutocompleteProductTemplate", function (_defaultTemplate, templateOptions, distinct, itemLink, trackSearchAttribution) {
      // Modify default options, then return them
      const { html, item, components } = templateOptions;
      const ratingsHTML = generateStarRating(item, html);
      const hasFreeGift = item?.meta?.custom?.hasfreegift || '';
      const hasFreeFurnitureCover = item?.meta?.custom?.hasfreefurniturecover || '';

      return html`
        <a
          href="${itemLink}"
          class="aa-ItemLink aa-ProductItem"
          onClick="${() => trackSearchAttribution(item)}"
        >
          <div class="aa-ItemContent">
            <div class="aa-ItemPicture aa-ItemPicture--loaded">
              <img
                src="${algoliaShopify.helpers.largeImage(item)}"
                alt="${item.title}"
                width="300"
                height="300"
              />
              ${ freeItemSnippet(hasFreeFurnitureCover, hasFreeGift, item.inventory_available, html)}
            </div>
            <div class="aa-ItemContentBody">
              <div class="aa-ItemContentTitleWrapper">
                <div class="aa-ItemContentTitle">
                  ${components.Highlight({ hit: item, attribute: "title" })}
                  <span class="algolia-variant">
                    ${algoliaShopify.helpers.variantTitleAddition(item, distinct)}
                  </span>
                </div>
              </div>
              <div class="aa-ItemContentPrice">
                <div class="aa-ItemContentPriceCurrent">
                  ${item.compare_at_price && item.compare_at_price !== "0" ?
                    html`<span class="aa-ItemComparePrice">${algoliaShopify.helpers.displayStrikedPrice(item.price, item.compare_at_price)}</span>` : ''}                
                  <span class="aa-ItemPrice">${algoliaShopify.helpers.displayPrice(item, distinct)}</span>
                </div>
              </div>

              <!-- Star ratings -->
              ${ ratingsHTML }
            </div>
          </div>
        </a>
      `;
    }
  );

  algoliaShopify.hooks.registerHook('beforeAutocompleteHeaderTemplate', function(_defaultTemplate, templateOptions, resource) {
    const { html, state } = templateOptions;

    return html`
      <div class="aa-SourceHeader">
        <span class="aa-SourceHeaderTitle">
          ${resource == 'Products' ? `Popular ${resource}` : resource }
        </span>
        <div class="aa-SourceHeaderLine" />
      </div>
    `;
  });

  algoliaShopify.hooks.registerHook('beforeAutocompleteFooterTemplate', function(_defaultTemplate, templateOptions) {
    const { html, state } = templateOptions;
    return html`
      <div class="aa-footer">
        <a
          href="${window.Shopify.routes.root}search?q=${state.query}"
        >
          ${algoliaShopify.translations.allProducts}
          (${algoliaShopify.helpers.formatNumber(state.context.nbProducts)})
        </a>
      </div>
    `;
  });

  document.querySelector('.header__icon--search').addEventListener('click', function() {
    const searchInput = document.querySelector('.aa-Input');
    const searchButton = document.querySelector('.aa-DetachedSearchButton');
    
    if ( searchInput ) {
      setTimeout(() => {
        searchInput.click();
        searchInput.focus();
      }, 100);
    }

    if ( searchButton ) {
      setTimeout(() => {
        searchButton.click();
      }, 100);
    }

    setTimeout(() => {
      loadSavingRecentSearches();
    }, 300);
  });

  document.querySelector('.header__icon--search-clone').addEventListener('click', function() {
    const searchIcon = document.querySelector('.header__icon--search');
    if (searchIcon) {
      searchIcon.click();
    }
  });

  document.querySelector('.search-modal__close-button').addEventListener('click', function() {
    const detailsElement = this.closest('details');
    if (detailsElement) {
        detailsElement.removeAttribute('open');
    }
  });

  document.body.addEventListener('click', function(event) {
    if (event.target.matches('.aa-DetachedCancelButton')) {
      setTimeout(() => {
        document.querySelector('.search-modal__close-button')?.click()
      }, 200)
    }
  })

  document.querySelector('details .search-modal .modal-overlay').addEventListener('click', function() {
    document.querySelector('.search-modal__close-button').click();
  });
});

document.addEventListener('submit', function(event) {
  if (event.target.classList.contains('aa-Form')) {
    document.querySelector('.search-modal__close-button').click()
  }
}, false);

window.addEventListener('load', function() {
  loadSavingRecentSearches()
});